import { TemplateTypes } from './email.template.item';
import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export interface IEmailTemplateBasicsItem {
    ID: number;
    Name: string;
    Description: string;
    TemplateType: TemplateTypes;
    SystemTemplate: boolean;
    LastUpdated: Date;
}


export class EmailTemplateBasicsItemArray extends Array<IEmailTemplateBasicsItem> {
    LastSort = new SortItem();

    constructor(...items: EmailTemplateBasicsItem[]) {
        super(...items);
        Object.setPrototypeOf(this, EmailTemplateBasicsItemArray.prototype);
    }

    static FixDates(items: EmailTemplateBasicsItemArray) {
        items.forEach(x => EmailTemplateBasicsItem.FixDate(x));
    }
}

export class EmailTemplateBasicsItem implements IEmailTemplateBasicsItem {
    ID: number;
    Name: string;
    Description: string;
    TemplateType: TemplateTypes;
    SystemTemplate: boolean;
    LastUpdated: Date;

    static FixDate(item: EmailTemplateBasicsItem) {
        item.LastUpdated = new Date(item.LastUpdated);
    }
}
